<template>
    <v-container style="margin: 0px;padding: 0px;">
        <v-snackbar v-model="showMessage" top :timeout="messageType=='error'?20000:800" :color="messageType"
                    multi-line>
            <v-btn icon @click="close()">
                <v-icon>close</v-icon>
            </v-btn>
            <!--            <v-icon dark class="mr-2" v-if="messageType=='success'">check_circle</v-icon>-->
            <!--            <v-icon dark class="mr-2" v-if="messageType=='error'">mdi-alert</v-icon>-->
            <!--            <v-icon dark class="mr-2" v-if="messageType=='info'">mdi-information</v-icon>-->
            <!--            <v-icon dark class="mr-2" v-if="messageType=='warning'">mdi-exclamation</v-icon>-->
            <v-container v-html="messageText"
                         :style="{display: messageText&&messageText.indexOf('<br/>')==-1?'inline':'block'}"
                         class="font-weight-bold"></v-container>
        </v-snackbar>
    </v-container>
</template>
<script>
    import store from "../../store";

    export default {
        name: "apm-app-message",
        // data() {
        //     return {
        //         showMessage: false
        //     };
        // },
        computed: {
            messageText: function () {
                return this.$store.getters.requestResponse.responseErrorMessage;
            },
            messageType: function () {
                return this.$store.getters.requestResponse.responseCode;
            },
            showMessage: {
                get() {
                    if (this.$store.getters.requestResponse.action == 'close') {
                        return false
                    }
                    if (this.$store.getters.requestResponse.responseCode) {
                        return true;
                    }
                    return false;
                },
                set() {
                    this.close();
                }
            }
        },
        methods: {
            close() {
                let item = {
                    messageType: this.$store.getters.requestResponse.responseCode,
                    messageText: this.$store.getters.requestResponse.responseErrorMessage,
                    action: 'close'
                }
                store.dispatch("showMessage", item)
            }
        }
    };
</script>